/**
 * 窗口历史记录器
 * 基于 session 会继承
 * 暂只支持新开页面溯源
 * todo: 平台内react路由系统记录
 */
export default class StaHistory {
  list: any;
  constructor() {
    const _list = this.getFromDb();
    this.list = _list || [];
    this.add(location);
  }

  get size() {
    return this.list.length;
  }

  syncToDb() {
    const value = JSON.stringify(this.list);
    sessionStorage.setItem("sota-history", value);
  }

  getFromDb() {
    const res: any = sessionStorage.getItem("sota-history");
    const value = JSON.parse(res);
    return value;
  }

  getList() {
    return this.list;
  }

  getNow() {
    return this.list[this.size - 1];
  }

  getLast() {
    return this.size - 2 > -1 ? this.list[this.size - 2] : {};
  }

  // item: location 对象
  add(item: any) {
    if (this.list.length >= 10) {
      this.remove(true);
    }

    this.list.push(item);
    this.syncToDb();
  }

  remove(prevent?: boolean) {
    this.list.shift();
    !prevent && this.syncToDb();
  }

  clear() {
    this.list = [];
    this.syncToDb();
  }
}
